var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Hero"}},[_c('ImageBox',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }